// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-22-2024
// ***********************************************************************
// <copyright file="_notificationInformation.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utilities for initializing and managing notifications, including 
//     automatic fade-out and removal of notification elements in a Blazor application.
// </summary>
// ***********************************************************************

window.notifications = window.notifications || {};

/**
 * Sets up a notification to fade out and be removed after a specified duration.
 * This function observes the DOM for the presence of the specified element and,
 * once found, triggers a fade-out animation after 3 seconds. Upon completion of the
 * animation, the element is removed via a Blazor method call.
 * 
 * @function informationclose
 * @memberof window.notifications
 * @param {string} elementId - The ID of the notification element to fade out and remove.
 * @param {object} dotNetHelper - The .NET object reference used to invoke methods in Blazor.
 */
window.notifications.informationclose = function (elementId, dotNetHelper) {
    const observer = new MutationObserver((mutations, observerInstance) => {
        const element = document.getElementById(elementId);
        if (element) {
            observerInstance.disconnect(); // Stop observing once the element is found

            setTimeout(() => {
                element.classList.add('fade-out');
                element.addEventListener('animationend', function () {
                    dotNetHelper.invokeMethodAsync('RemoveMessage', elementId);
                });
            }, 3000); // Start fade out after 3 seconds
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // If the element is already present when this function is called
    const element = document.getElementById(elementId);
    if (element) {
        observer.disconnect();
        setTimeout(() => {
            element.classList.add('fade-out');
            element.addEventListener('animationend', function () {
                dotNetHelper.invokeMethodAsync('RemoveMessage', elementId);
            });
        }, 3000); // Start fade out after 3 seconds
    }
};
